import { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { GET_ATTN_ID } from '../constants/attn.constants';
import { EventDto } from '@sweatpals/shared';
import { APP_ENV } from '../constants';

export const useAttentive = (props?: { event?: EventDto }): {
	enableAttentive: boolean;
	ATTN_ID: string;
	attnScript: ReactNode;
} => {
	const { event } = props ?? {};

	const router = useRouter();

	const [ATTN_ID, setATTN_ID] = useState<string>('');

	const enableAttentive = !!ATTN_ID;

	const getAttnId = useCallback(() => {
		// enabled only on prod environment
		if (APP_ENV !== 'main') {
			return;
		}

		if (typeof event?.additionalData?.tracking?.attnId === 'string') {
			setATTN_ID(event.additionalData.tracking.attnId);

			return;
		}

		const attnId = GET_ATTN_ID(window.location.pathname)?.attnId;
		setATTN_ID(attnId || '');
	}, [event?.additionalData?.tracking?.attnId]);

	useEffect(() => {
		getAttnId();
	});

	const handleRouteChange = useCallback(() => {
		getAttnId();
	}, [getAttnId]);

	useEffect(() => {
		router.events.on('routeChangeComplete', handleRouteChange);

		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};
	}, [router.events, handleRouteChange]);

	const attnScript = useMemo(() => {
		if (!enableAttentive) {
			return null;
		}

		return <Script id='attentive-inc' strategy='afterInteractive' src={`https://cdn.attn.tv/${ATTN_ID}/dtag.js`} />;
	}, [ATTN_ID, enableAttentive]);

	return { enableAttentive, ATTN_ID, attnScript };
};
